export default __webpack_public_path__ + "static/media/zahnraeder.7f5f0986.svg";